import React from 'react';

import { Button as PrimeReactButton } from 'primereact/button';

const Button: React.FC<any> = (props): JSX.Element => {
    const { className, helperText, ...passThroughProps } = props;

    return (
        <div className="d-inline-block align-top text-center button-wrapper">
            <PrimeReactButton {...passThroughProps} className={`${className} p-button-rounded`} />
            {helperText &&
                <p className="pt-2">
                    {helperText}
                </p>
            }
        </div>
    );
}

export default Button;
